"use client"

import posthog from "posthog-js"

import type { AnalyticsProvider } from "../types"

// Client-side PostHog (posthog-js). CLIENT ONLY. The posthog-js singleton is
// init'd in instrumentation-client.ts; it manages the current distinctId
// itself, so capture/exception ignore the passed distinctId.
export const posthogClientProvider: AnalyticsProvider = {
  capture(_distinctId, event, properties) {
    posthog.capture(event, properties)
  },
  identify(distinctId, properties) {
    posthog.identify(distinctId, properties)
  },
  alias(distinctId, alias) {
    posthog.alias(alias, distinctId)
  },
  captureException(error, _distinctId, properties) {
    posthog.captureException(error, properties)
  },
}
